import React from 'react';
import { Box } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { colors, typography } from '../styles/theme';
import { formatCollectionInquiryCountLabels } from '../Map/utils/collectionInquiryStats';

const labelSx = {
  fontSize: '11px',
  fontWeight: 600,
  fontFamily: typography.fontFamily.primary,
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

/**
 * Manage: una píldora `icono + “2 consultas”` y, si hay, `“1 nueva”` adentro.
 * Si ambos son 0, no renderiza. El visitante no lo ve.
 * `onClick` abre la bandeja (detalle de lista).
 */
export default function CollectionInquiryBadge({
  unseen = 0,
  total = 0,
  sx = undefined,
  onClick,
}) {
  const { totalLabel, unseenLabel } = formatCollectionInquiryCountLabels({ total, unseen });
  if (!totalLabel && !unseenLabel) return null;
  const clickable = typeof onClick === 'function';
  const ariaLabel = [totalLabel, unseenLabel].filter(Boolean).join(', ');
  return (
    <Box
      component={clickable ? 'button' : 'div'}
      type={clickable ? 'button' : undefined}
      onClick={clickable ? onClick : undefined}
      aria-label={clickable ? `Ver consultas: ${ariaLabel}` : ariaLabel}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        minWidth: 0,
        py: 0.5,
        pl: 1,
        pr: unseenLabel ? '3px' : 1.25,
        borderRadius: '999px',
        border: `1px solid ${colors.border}`,
        bgcolor: 'transparent',
        color: colors.textSecondary,
        boxSizing: 'border-box',
        ...(clickable ? {
          cursor: 'pointer',
          m: 0,
          font: 'inherit',
          '&:focus-visible': { outline: `2px solid ${colors.primary}`, outlineOffset: 2 },
        } : {}),
        ...sx,
      }}
    >
      <ChatBubbleOutlineIcon sx={{ fontSize: 14, color: colors.primary, flexShrink: 0 }} />
      {totalLabel ? (
        <Box component="span" sx={{ ...labelSx, color: colors.textSecondary }}>
          {totalLabel}
        </Box>
      ) : null}
      {unseenLabel ? (
        <Box
          component="span"
          sx={{
            ...labelSx,
            display: 'inline-flex',
            alignItems: 'center',
            height: 20,
            px: 1,
            borderRadius: '999px',
            bgcolor: colors.primary,
            color: colors.textPrimary,
          }}
        >
          {unseenLabel}
        </Box>
      ) : null}
    </Box>
  );
}
